export function getCookie(name) {
    const m = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"))
    return m ? decodeURIComponent(m[2]) : null
}
